export default function Ornamento() {
  return (
    <svg className="ba-ornamento" viewBox="0 0 200 12" aria-hidden="true">
      <line x1="0" y1="6" x2="84" y2="6" stroke="currentColor" strokeWidth="1" />
      <rect x="93" y="0.8" width="10.4" height="10.4" transform="rotate(45 98 6)" fill="currentColor" />
      <line x1="116" y1="6" x2="200" y2="6" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}
